<template>
  <div>
    <h3>Grafika użyta na stronie:</h3>
    <a href="https://www.freepik.com/free-photos-vectors/people">People vector created by studiogstock - www.freepik.com</a>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>